/***
 * @Author: ZhaoG
 * @Date: 2025-04-09 10:57:57
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-05 11:31:11
 * @FilePath: \sra-fe\src\utils\index.js
 * @Description:
 */
/**
 * Created by jiachenpan on 16/11/18.
 */
import store from '../store'
import {filePreview } from '../api/supRegister'

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) {
      s++
    } else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"') +
    '"}'
  )
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [{
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }
]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

export function trans(obj) {
  const _routeObj = {}
  _routeObj.name = obj.name
  _routeObj.path = obj.url
  _routeObj.redirect = obj.redirect || ''
  _routeObj.meta = obj.meta || {}
  _routeObj.meta.title = obj.name
  _routeObj.meta.isNotShow = obj.isNotShow
  return _routeObj
}

export function routerObj2MenuObj(item) {
  const menuObj = {}
  menuObj.subMenuTitle = item.name
  if (item.subMenu.length) {
    const subMenuArr = []
    item.subMenu.forEach(menuItem => {
      subMenuArr.push(trans(menuItem))
    })
    menuObj.subMenu = subMenuArr
  }
  return menuObj
}

export function getCurMenuObj(arr, menuCode) {
  // let obj = {}
  // let menu = []

  if (arr.length !== 0) {
    var traverse = (arr) => {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
          // 获取当前菜单
          if (arr[i].menuCode === menuCode) {
            // 获取当前菜单的父菜单
            // obj = arr[i]
            const strArr = arr[i].id.split('-')
            const curMenuId = strArr[0] + '-' + strArr[1]

            const curMenu = store.state.app.menu.forEach(item => {
              return item.id === curMenuId
            })
            console.log('**************11111111')
            console.log(curMenu)
            store.dispatch('setCurrentMenuArr', curMenu)
          }
          traverse(arr[i].subMenu)
        } else {
          if (arr[i].menuCode === menuCode) {
            // 获取当前菜单的父菜单
            // alert(3)
            // obj = arr[i]
            const strArr = arr[i].id.split('-')
            const curMenuId = strArr[0] + '-' + strArr[1]
            const curMenu = store.state.app.menu.filter(item => {
              return item.id === curMenuId
            })
            const menuArr = []
            curMenu[0].subMenu.forEach(item => {
              const menuObj = routerObj2MenuObj(item)
              menuArr.push(menuObj)
            })
            store.dispatch('setCurrentMenuArr', menuArr)
          }
        }
      }
    }
    traverse(arr)
  }

  // return menu
}

export function addUrlPerFix(url) {
  if (window.location.hostname === "localhost") {
    return window.location.protocol + "//dev01-" + url;
    // return window.location.protocol + "//uat01-" + url;
  } else {
    let arr = window.location.hostname.split("-");
    let perfix = arr.length === 1 ? "" : arr[0] + "-";
    console.log(window.location.protocol + "//" + perfix + url);
    return window.location.protocol + "//" + perfix + url;
  }
}
export function dateFormat(fmt, date) {
  let ret;
  let opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}


/**
 * huanghui
 * @param orgtime
 * @param format
 * @returns {string|*}
 */
export function formatDate(orgtime, format) {
  //根据毫秒数格式化时间(北京)
  if (orgtime == "" || orgtime == null) {
    return "";
  }
  var time = Number(orgtime);
  //创建一个Date对象
  var instance = new Date(time);
  var localTime = instance.getTime();
  //获得当地时间偏移的毫秒数
  var localOffset = instance.getTimezoneOffset() * 60000;
  var utc = localTime + localOffset; //utc即GMT时间
  var offset = 8; //东8区
  var beijing = utc + 3600000 * offset;
  var t = new Date(beijing);
  var tf = function(i) {
    return (i < 10 ? "0" : "") + i;
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function(a) {
    switch (a) {
      case "yyyy":
        return tf(t.getFullYear());
      case "MM":
        return tf(t.getMonth() + 1);
      case "mm":
        return tf(t.getMinutes());
      case "dd":
        return tf(t.getDate());
      case "HH":
        return tf(t.getHours());
      case "ss":
        return tf(t.getSeconds());
    }
  });
}

//为复制删除加标志
export function generateUUID() {
  let d = new Date().getTime();
  let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
    c
  ) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
  // URL.createObjectURL(new Blob()).substr(-36)
}
// 数字转为千分位
export function numberFilter(oldNum, isFixed) {
  if (oldNum === "") return {};
  let newNum = oldNum.toLocaleString("en-US");
  const numArr = newNum.split(".");
  if (!isFixed) {
    if (!numArr[1]) {
      newNum = newNum + ".00";
    } else if (numArr[1].length === 1) {
      newNum = newNum + "0";
    } else if (numArr[1].length >= 2) {
      newNum = numArr[0] + "." + numArr[1].substr(0, 2);
    }
  }
  return { oldNum, newNum };
}

// 数组对象去重
export function uniqueByJson(arr, value) {
  return arr.reduce((pre, cur) => {
    if (pre.find(c => c[value] === cur[value])) {
      return pre;
    } else {
      return [...pre, cur];
    }
  }, []);
}

export const footerLinks = {
  contactUs: addUrlPerFix(process.env.VUE_APP_EMP_URL + "/contactUs.html"),
  introduction: addUrlPerFix(process.env.VUE_APP_EMP_URL + "/introduction.html"),
  guide: addUrlPerFix(process.env.VUE_APP_EMP_URL + "/guide.html")
};

export function isShowViewBtn(fileName) {
  if (fileName) {
    let arr = fileName.split(".");
    console.log(arr);
    console.log(arr[arr.length - 1]);

    if (
      arr[arr.length - 1].toLowerCase() == "pdf" ||
      arr[arr.length - 1].toLowerCase() == "png" ||
      arr[arr.length - 1].toLowerCase() == "jpg" ||
      arr[arr.length - 1].toLowerCase() == "bmp" ||
      arr[arr.length - 1].toLowerCase() == "jpeg"
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

//附件预览
export async function getPreviewUrl(uploadId) {
  let { data } = (await filePreview({ uploadId })).data;
  const link = document.createElement("a");
  link.href = data;
  link.target = "_blank";
  link.rel = "noopener noreferrer"; // 安全建议
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

}

// 设置sessionStorage项
export function setSessionItem(moduleName, key, value) {
  let val = getSessionItem(moduleName) || {};
  val[key] = value;
  sessionStorage.setItem(moduleName, JSON.stringify(val));
}
// 读取sessionStorage项
export function getSessionItem(moduleName, key) {
  if (key) {
    return (
      sessionStorage.getItem(moduleName) &&
      JSON.parse(sessionStorage.getItem(moduleName))[key]
    );
  } else {
    return JSON.parse(sessionStorage.getItem(moduleName));
  }
}
// 删除缓存项
export function removeSessionItem(moduleName, key) {
  if (key) {
    let val = getSessionItem(moduleName);
    delete val[key];
    sessionStorage.setItem(moduleName, JSON.stringify(val));
  } else {
    sessionStorage.removeItem(moduleName);
  }
}

